import { render } from "./CategorySummary.vue?vue&type=template&id=45083cec&scoped=true"
import script from "./CategorySummary.vue?vue&type=script&lang=js"
export * from "./CategorySummary.vue?vue&type=script&lang=js"

import "./CategorySummary.vue?vue&type=style&index=0&id=45083cec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45083cec"]])

export default __exports__